// extracted by mini-css-extract-plugin
export default {"emptyDiv":"emptyDiv__3jU3w"};